import React from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { SeparationType } from '../../enums/SeparationType';
import { AssemblerManagementOption } from '../../enums/AssemblerManagementOption';
import { DropdownButton, DropdownButtonColor } from '../../common-components/DropdownButton/DropdownButton'
import { If } from '../../common-components/If/If';
import { ModalAssemblerOrderDetails } from '../ModalAssemblerOrderDetails/ModalAssemblerOrderDetails';

interface IAssemblerOrderManagementButtonProps {
  orderId?: number;
  orderNumber?: string;
  separationType?: SeparationType;
  clickItem?: (key: any) => void;
  modalClosed?: () => void;
}

export const AssemblerOrderManagementButton: React.FC<IAssemblerOrderManagementButtonProps> = ({
  orderId,
  orderNumber,
  separationType,
  clickItem,
  modalClosed
}) => {

  const [modalInfo, setModalInfo] = React.useState({ visible: false });

  const {
    generateTSOReportService
  } = React.useContext(ServicesContext);

  if (separationType !== SeparationType.Prescription) return null;

  const options = [
    {
      key: AssemblerManagementOption.PrintTSO,
      text: `TSO`
    },
    {
      key: AssemblerManagementOption.ManageOrder,
      text: `Detalhes do Pedido`
    }
  ];

  return (
    <>
      <DropdownButton
        items={options}
        defaultStyle={true}
        small={true}
        buttonColor={DropdownButtonColor.Success}
        text={''}
        clickItem={(key) => clickItem ? clickItem(key) : handleClickItem(key)}
      />
      <If condition={modalInfo.visible}>
        <ModalAssemblerOrderDetails
          title={`Detalhes do Pedido ${orderNumber}`}
          visible={modalInfo.visible}
          orderId={orderId}
          close={() => {
            setModalInfo({visible:false});
            modalClosed && modalClosed();
          }}
        />
      </If>
    </>
  );

  function handleClickItem(key: any) {
    if (!orderId) return;
    
    if (key === AssemblerManagementOption.ManageOrder) {
      setModalInfo({visible:true});
      return;
    }

    if (key === AssemblerManagementOption.PrintTSO) {
      generateTSOReportService.handle({orderIds: [orderId]});
    }
  }

}